<template>
  <div id="vista-seleccion-administracion" v-if="acuerdo_comercial_copy">
    <div class="pa-6">
      <div class="titulo-principal mb-4">Configuración del acuerdo</div>
      <v-form
        ref="formulario_vista_seleccion_administracion"
      >
        <busqueda-administracion
          ref="busqueda_administracion"
          :administracion.sync="acuerdo_comercial_copy.administracion"
          :administraciones="administraciones"
        />

        <ca-chip
          v-if="errorAdministracion"
          :item="{'label': 'La administración ya tiene un acuerdo por defecto.<br>Elegí otra administración'}"
          disabled
          outline
          contentClass="chip-custom chip-warning"
        >
          <div slot="izquierda">
            <v-icon class="icon-warning">warning</v-icon>
          </div>
        </ca-chip>

        <div v-if="!errorAdministracion && acuerdo_comercial_copy.administracion">
          <opcion-plantilla-personalizada
            ref="opcion_plantilla_personalizada"
            :plantillas="plantillas"
            :acuerdo_comercial.sync="acuerdo_comercial_copy"
          >
          </opcion-plantilla-personalizada>
        </div>

      </v-form>
    </div>
  </div>
</template>

<script>
import { AcuerdoComercial } from '../../../../models/AcuerdoComercial';
import BusquedaAdministracion from '../BusquedaAdministracion.vue';
import OpcionPlantillaPersonalizada from '../OpcionPlantillaPersonalizada.vue';

export default {
  name:'VistaSeleccionAdministracion',
  components: {
    BusquedaAdministracion,
    OpcionPlantillaPersonalizada
  },
  props:{
    acuerdo_comercial: { type: AcuerdoComercial, default: () => new AcuerdoComercial() },
    plantillas: { type: Array, default: () => [] },
    administraciones: { type: Array, default: () => [] },
  },
  data: () => ({
    acuerdo_comercial_copy: null,
  }),

  computed: {
    /**
     * Calculo si tiene la administración seleccionada tiene error:
     *  - tiene AC asignada
     */
    errorAdministracion() {
      return this.acuerdo_comercial_copy.administracion && this.acuerdo_comercial_copy.administracion.tiene_acuerdo_comercial;
    },
  },

  /**
   * Al montarse el componente, se crea una copia deep del AC original, para modificarla.
   */
  mounted(){
    this.acuerdo_comercial_copy = _.cloneDeep(this.acuerdo_comercial);
  },

  methods: {
    /**
     * Metodo invocado desde el padre, para validar el formulario de selección de administracion que consiste en: 
     *  - Validar la opcion de metodo de creación (que haya seleccionado una plantilla)
     *  - Que la administración no tenga errores (solo por defecto)
     *  - Que se haya seleccionado una administración
     * Si pasa todas las validaciones, actualiza el AC
     */
    validarFormulario(){
      let valido = true;
      valido = this.$refs.formulario_vista_seleccion_administracion.validate() && !this.errorAdministracion;

      if(valido && this.acuerdo_comercial_copy.administracion){
        this.$emit('update:acuerdo_comercial', this.acuerdo_comercial_copy);
      }

      return valido;
    },
  },
};
</script>

<style lang="scss">
#vista-seleccion-administracion{
  .v-chip__content .ca-chip-izquierda{
    padding-right: 7px;
  }
}
</style>